import React from "react"
import { Alert } from "@mui/material"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"

const CommentsAlert = ({ children }) => {

	return (
		<Alert
			iconMapping={{
				info: <InfoOutlinedIcon sx={{
					width: 24,
					height: 24
				}} />,
			}}
			severity="info"
			sx={{
				padding: "8px 16px",
				backgroundColor: "#E3F2FD",
				maxWidth: "fit-content",
				".MuiAlert-icon": {
					color: "#0288D1",
				},
				".MuiAlert-message": {
					color: "#262626",
					fontSize: 18,
					lineHeight: "24px"
				}
			}}>{children}
		</Alert>
	)
}

export default CommentsAlert